import React from 'react'
import { connect } from 'react-redux'
import { clickLogout } from '../../actions/auth'

const LogoutContainer = ({ clickLogout, children }) =>
  React.cloneElement(children, { onClick: () => clickLogout() })

export default connect(null, { clickLogout })(LogoutContainer)
